import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { TemplateConfig } from 'src/app/models/template-config';

export const getTemplateConfiguration = createAction(
  '[Template Config] Get Template Configuration',
  props<{ studyId: number; templateId: number; profileId: number }>()
);

export const getTemplateConfigurationSuccess = createAction(
  '[Template Config] Get Template Configuration Success',
  props<{ templateConfig: TemplateConfig }>()
);

export const getTemplateConfigurationError = createAction(
  '[Template Config] Get Template Configuration Error',
  props<{ err: HttpErrorResponse }>()
);

export const saveTemplateConfiguration = createAction(
  '[Template Config] Save Template Configuration',
  props<{ config: TemplateConfig; studyId: number }>()
);

export const saveTemplateConfigurationSuccess = createAction('[Template Config] Save Template Configuration Success');

export const saveTemplateConfigurationError = createAction(
  '[Template Config] Save Template Configuration Error',
  props<{ err: HttpErrorResponse }>()
);
